import { baseApi } from '@shared/api'

export const businssCardApi = baseApi.injectEndpoints({
  endpoints(builder) {
    return {
      fetchBusinessCard: builder.query<any, { currency: string }>({
        query: ({ currency }) => ({
          url: '/ib/order/card/salary/cards/by-currency',
          data: { currency },
          method: 'POST',
          skipGlobalError: true,
        }),
      }),
      fetchOrderInfo: builder.query<any, any>({
        query: () => ({
          url: '/ib/order/card/salary/configs',
          data: {   orderType:"SCO", },
          method: 'POST',
        }),
      }),
    }
  },
})

export const {
  useFetchBusinessCardQuery,
  useLazyFetchBusinessCardQuery,
  useLazyFetchOrderInfoQuery,
  useFetchOrderInfoQuery
} = businssCardApi
